import React, { useEffect, useRef, useState } from "react";
import "./ProfilePopUp.css"; // Make sure to create this CSS file
import { FaLock, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useAuth } from "../../AuthContext";
import { currencyReturn } from "../../Api";
import instance, {
} from "../../Api";
import toast, { Toaster } from "react-hot-toast";
import AppToast from "../../AppToast";
import { FaCopy } from "react-icons/fa";


const ProfilePopUp = (props) => {
  const { logout, smuser, isLoginByParentUser } = useAuth();
  const { type, wallet, upnetcredits, isVisible, onClose } = props;
  const { appCurrency } = useAuth();
  const [showSsoPopup, setShowSsoPopup] = useState(false);
  const [generatedSsoUrl, setGeneratedSsoUrl] = useState("");

  const modalRef = useRef();

  function isMobileDevice() {
    return window.matchMedia("(max-width: 800px)").matches;
  }

  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Call the close function
      }
    };

    function handleResize() {
      setIsMobile(isMobileDevice());
    }

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup listener on component unmount or if isVisible changes
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, onClose, isMobile]);

  if (!isVisible) return null;

  const logoutFunc = () => {
    try {
      logout();
    } catch (error) {
      console.error("Error occurred during logout:", error);
    }
  };
  const handleGenerateSso = async () => {
    try {
      const res = await instance.post("/generate-sso-link", {
        user_id: smuser.id,
      });

      if (res.data.success) {
         toast((t) => (
          <AppToast
            id={t.id}
            message={'SSO link generated successfully'}
            isMobile={isMobile}
          />
        ));
        setGeneratedSsoUrl(res.data.url);
        setShowSsoPopup(true);
      }
    } catch (err) {
      console.error(err);
      toast((t) => (
          <AppToast
            id={t.id}
            message={'Failed to generate SSO link'}
            isMobile={isMobile}
          />
        ));
    }
  };
  const copySsoUrl = async () => {
    if (!generatedSsoUrl) return;

    await navigator.clipboard.writeText(generatedSsoUrl);
    toast((t) => (
      <AppToast
        id={t.id}
        message={'Copied to clipboard'}
        isMobile={isMobile}
      />
    ));
  };

  return (
    
    <div
      className="main-view-popup"
      ref={modalRef}
      style={{
        backgroundImage: "url('/admin/images/admin/02-vm/gray-box-bg.png')",
        height:
          type !== "profile"
            ? "15rem"
            : isLoginByParentUser == 1
            ? "25.5rem"
            : "20rem",
      }}
    >
      
      {showSsoPopup && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99999 }}>
          <div style={{ background: "#07528b", padding: "25px", borderRadius: "12px", width: "500px", position: "relative" }}>
            
            <button
              onClick={() => setShowSsoPopup(false)}
              style={{ position: "absolute", right: "10px", top: "10px", background: "transparent", border: "none", color: "#e97730", fontSize: "18px" }}
            >
              ✕
            </button>

            <h4 style={{ color: "white" }}>Generated SSO Link</h4>

            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                value={generatedSsoUrl}
                readOnly
                style={{ flex: 1, padding: "10px", borderRadius: "8px" }}
              />

              <button
                onClick={copySsoUrl}
                style={{ background: "#e97730", border: "none", padding: "8px 12px", borderRadius: "8px", color: "white" }}
              >
                <FaCopy />
              </button>
            </div>
          </div>
        </div>
      )}

      {type === "profile" ? (
        <>
          <div
            style={{
              display: "grid",
              justifyItems: "center",
              marginTop: "10px",
            }}
          >
            <div
              className=""
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                outline: "2px solid #035189",
                border: "5px solid white",
              }}
            >
              <div className="">
                  <img
                    src="/user.png"
                    style={{
                      width: "90px",
                      height: "90px",
                      borderRadius: "50%",
                      backgroundColor: "#035189",
                      outline: "2px solid #035189",
                      border: "5px solid white",
                    }}
                  />
              </div>
              <div className="profile-badge">{smuser && smuser.email}</div>
            </div>
          </div>

          <ul style={{ marginLeft: "25px" }}>
            <li>
              <a href="/edit-profile" className="profile-menuitem">
                <FaUser
                  style={{ width: "20px", height: "20px", paddingRight: "5px" }}
                />
                Profile
              </a>
            </li>
            <li>
              <a href="/change-password" className="profile-menuitem">
                <FaLock
                  style={{ width: "20px", height: "20px", paddingRight: "5px" }}
                />
                Change Password
              </a>
            </li>

            {isLoginByParentUser == 1 && (
              <li>
                <a href="/settings" className="profile-menuitem">
                  <FaUser
                    style={{
                      width: "20px",
                      height: "20px",
                      paddingRight: "5px",
                    }}
                  />
                  Settings
                </a>
              </li>
                
            )}


            {/* {isLoginByParentUser == 1 && (
              <li onClick={handleGenerateSso}>
                  <a className="profile-menuitem">
                    <FaUser
                      style={{ width: "20px", height: "20px", paddingRight: "5px" }}
                    />
                     Generate SSO
                  </a>
              </li>
            )} */}
            <li onClick={logoutFunc}>
              <a className="profile-menuitem">
                <FaSignOutAlt
                  style={{ width: "30px", height: "30px", paddingRight: "5px" }}
                />{" "}
                Logout
              </a>
            </li>
          </ul>
        </>
      ) : (
        <div>
          <div>
            <a href="/wallet">
              <h5
                style={{
                  textAlign: "center",
                  padding: "18px",
                  color: "#154e7a",
                }}
              >
                Total Balance <br />({wallet})
              </h5>
            </a>
            {upnetcredits && upnetcredits > 0 && (
              <a href="/wallet">
                <h5
                  style={{
                    textAlign: "center",
                    padding: "18px",
                    color: "#154e7a",
                  }}
                >
                  UPNETCredits <br />(
                  {currencyReturn({
                    price: upnetcredits,
                    symbol: smuser.prefer_currency,
                    rates: appCurrency,
                  })}
                  )
                </h5>
              </a>
            )}
          </div>
          <ul>
            <li style={{ marginTop: "10px", marginLeft: "25px" }}>
              <a
                href="/wallet"
                className="profile-menuitem"
                style={{ fontSize: "21px" }}
              >
                <FaLock
                  style={{ width: "20px", height: "20px", paddingRight: "5px" }}
                />
                My Wallet
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProfilePopUp;
